import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function LightBulb(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "LightBulb", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.4382 44.9999h-.2935c-2.0614 0-3.7326-1.7368-3.7326-3.8793h7.7586c.0001 2.1426-1.671 3.8793-3.7325 3.8793Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M36.7065 22.3405c0-6.7038-5.4528-12.1502-12.2187-12.2531-6.8212-.10383-12.5091 5.3384-12.6076 12.0721-.0686 4.695 2.5387 8.7933 6.4119 10.9091l.1285 1.8958c.0134.1966.1019.3809.2477.5155.1458.1346.338.2095.5376.2095h10.1736c.1997 0 .3918-.0749.5376-.2095.1458-.1346.2344-.3189.2477-.5155l.1286-1.8958c3.8233-2.0887 6.4131-6.1091 6.4131-10.7281Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M29.5441 41.8969H19.0453c-.5288 0-.9574-.4475-.9574-.9995v-2.6562c0-.1313.0247-.2613.0728-.3825.0482-.1213.1187-.2315.2076-.3243.0889-.0928.1944-.1664.3106-.2166.1162-.0502.2407-.0761.3664-.0761h10.4988c.1258 0 .2503.0258.3665.0761.1162.0502.2217.1238.3107.2166.0889.0928.1594.203.2075.3243.0481.1212.0729.2512.0729.3825v2.6562c-.0001.552-.4288.9995-.9576.9995Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M22.9682 35.6897h-2.0887v-3.5188c-.9019-.9398-3.0753-3.6714-3.4725-8.4993L17.3105 22.5h5.0188v2.16h-2.6999c.6746 4.208 2.855 6.1201 2.9554 6.2063l.3784.3237.0049.5123v3.9874h.0001Zm4.739 0h-2.0887v-4.5034l.388-.3242c.096-.0823 2.276-1.994 2.9508-6.202h-2.7001v-2.16h5.0189l-.0965 1.1716c-.3975 4.828-2.5706 7.5595-3.4725 8.4992v3.5188h.0001Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21.9668 38.793h4.6552v1.5517h-4.6552V38.793Zm2.3263-30.26778c-.634 0-1.1479-.50954-1.1479-1.13804V4.13804c0-.6285.5139-1.13804 1.1479-1.13804.634 0 1.148.50954 1.148 1.13804v3.24914c0 .6285-.514 1.13804-1.148 1.13804ZM12.2774 13.5288c-.4483.4444-1.1751.4444-1.6234 0l-2.31778-2.2977c-.44829-.4445-.44829-1.1649 0-1.60943.4483-.4444 1.17516-.4444 1.62346 0l2.31772 2.29763c.4484.4445.4484 1.165 0 1.6095Zm24.0314 0c.4483.4444 1.1751.4444 1.6234 0l2.3178-2.2977c.4483-.4445.4483-1.1649 0-1.60943-.4483-.4444-1.1752-.4444-1.6235 0l-2.3177 2.29763c-.4483.4445-.4483 1.165 0 1.6095Z",
        fill: theme.vars.palette.primary.light
      }
    )
  ] });
}
LightBulb.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "LightBulb"
};
validateTidalLicense();
export {
  LightBulb
};
//# sourceMappingURL=LightBulb.js.map
